import { jwtDecode } from "jwt-decode";
import { decrypt } from "./other";
import { CY_SSO_BASE_URL } from "../services/constants";
import { clearAuthCookies } from "./cookieUtils";

export const auth = () => !!decrypt(localStorage.user);

/**
 * Single point for logging out: tells cy-sso to invalidate the session tied
 * to the current access token, then clears local session state. Every call
 * site is immediately followed by a navigation (window.location.replace),
 * which can abort a plain XHR/Axios request mid-flight. `fetch` with
 * keepalive:true is built for exactly this — the browser guarantees the
 * request is sent even though the page is unloading. (navigator.sendBeacon
 * can't be used instead since it doesn't support custom headers, and we
 * need to send the token via Authorization.) Still fire-and-forget:
 * localStorage gets cleared regardless of whether the backend call succeeds.
 */
export const logoutUser = () => {
  const accessToken = decrypt(localStorage.getItem("user"))?.ACCESS_TOKEN;
  if (accessToken) {
    fetch(`${CY_SSO_BASE_URL}api/logout`, {
      method: "POST",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }).catch(() => {});
  }
  // Clear the shared cross-app cy-sso cookies too, or the boot bootstrap (here
  // and in the standalone Sandbox) would silently re-create the dead session.
  // Runs BEFORE localStorage.clear() so clearAuthCookies can still read the
  // session role and raise the `cy_logged_out` signal for the student guard.
  try {
    clearAuthCookies();
  } catch (_) {
    /* never block logout */
  }
  localStorage.clear();
};

export const getUser = () => {
  const user = decrypt(localStorage.user);
  if (Object.keys(user).length > 0) {
    try {
      const userObj = jwtDecode(user?.ACCESS_TOKEN);
      return {
        studentId: userObj?.userId,
        studentEmail: userObj?.studentEmail,
      };
    } catch {
      return {};
    }
  } else {
    return {};
  }
};
